import { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Button from '../../Nodes/Button'
import TextField from '../../Nodes/TextField'
import { H4, Body1, Body2 } from '../../Nodes/Typography'
import { AUTH_URL } from '../../../utilities/constants'
import { isValidEmail, isCommonEmail } from '../../../utilities/email'
import { post } from '../../../utilities/requests'

class CheckSubscription extends Component {
    state = {
        completed: false,
        success: false,
        validEmail: true,
        corporateEmail: true,
        email: '',
        response: undefined,
    }

    handleSubmit = (e) => {
        e && e.preventDefault()

        const { email } = this.state
        const { role } = this.props

        if (!isValidEmail(email)) 
            this.setState({ validEmail: false, corporateEmail: true })
        else if (isCommonEmail(email))
            this.setState({ validEmail: true, corporateEmail: false })
        else {
            post(AUTH_URL + '/user/hasSubscription', { email, role }, 'application/json')
                .then(response => {
                    if (response.status !== 200)
                        this.setState({ completed: true, success: false })
                    else 
                        return response.json()
                })
                .then(data => {
                    this.setState({ 
                        completed: true, 
                        success: true, 
                        response: data 
                    })
                })
                .catch(error => {
                    console.error({ error })
                    this.setState({ completed: true, success: false })
                })
        }
    }

    renderIncomplete = () => {
        const { validEmail, corporateEmail } = this.state
        
        const errorText = 
            !validEmail ? 'Please enter a valid email.' :
            !corporateEmail ? `You have entered a personal email address. Please enter your corporate email address to confirm if your company subscribes to  ${this.props.productName}.` :
            ''

        return (
            <Fragment>
                { errorText && <Body2 className="check-subscription__error red-text">{errorText}</Body2> }
                <form onSubmit={this.handleSubmit}>
                    <TextField 
                        type="email"
                        label="Email"
                        required
                        value={this.state.email}
                        onChange={e => this.setState({ email: e.target.value })}
                    />
                    <div className="flex flex--end">
                        <Button raised secondary>Confirm</Button>
                    </div>
                </form>
            </Fragment>
        )
    }

    renderComplete = () => {
        const { success, response } = this.state

        if (!success) 
            return <Body2 className="check-subscription__error red-text">There was an error connecting to our servers. Please try again later.</Body2>
        else {
            let { productName, shortProductName } = this.props
            if (!shortProductName)
                shortProductName = productName

            let responseMessage = ''
            let callToAction = ''

            if (response.hasSubscription && response.hasAccount) {
                responseMessage = `Your company subscribes to ${productName} and you already have an account setup. You can login in the top right corner of this page.`
                callToAction = <Fragment>If you don't know your username or password, you can <a href={AUTH_URL + '/RecoverAccount'} target="_blank" rel="noreferrer">Recover your account</a>.</Fragment>                
            }
            else if (response.hasSubscription && !response.hasAccount) {
                responseMessage = `Your company subscribes to ${shortProductName}, but you do not have an account registered with Canadian Discovery Ltd.`
                callToAction = <Fragment>To access {shortProductName}, please <a href={AUTH_URL + '/Register'} target="_blank" rel="noreferrer">Create an Account</a>.</Fragment>
            }
            else {
                responseMessage = <Fragment>Your company <b>does not</b> subscribe to {productName}.</Fragment>
                callToAction = <Fragment>For subscription details, please <a href="/contact">contact us</a>.</Fragment>
            }

            return (
                <Fragment>
                    <Body1>{responseMessage}</Body1>
                    <Body1>{callToAction}</Body1>
                </Fragment>
            )
        }
    }

    render() {
        return (
            <div className="check-subscription">
                <H4>{this.props.message || 'Subscription Required'}</H4>
                {this.state.completed ?
                    this.renderComplete() :
                    this.renderIncomplete() }
            </div>
        )
    }
}

CheckSubscription.propTypes = {
    message: PropTypes.string,
    productName: PropTypes.string.isRequired,
    shortProductName: PropTypes.string,
    role: PropTypes.string.isRequired
}

export default CheckSubscription